import React, { Component } from "react";
// import ReactDOM from 'react-dom';
import "./css/index.css";
import "./css/index2.css";
import logo from "../data/images/Loading-Img.gif";
// import thri_dot from "../data/images/3dot.png";
// import './css/prism.js';
import { Notebook_data, insertCell, updateCell } from "./../data/data";
import { Editor, Display } from "./xCompo";
import { ToggleMenu } from "../../login";
// import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
// import { dark, coldarkDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

// const fs = require("fs");

class notebook extends Component {
  state = {
    // topics: [],
    user: "Guest",
    open_topic: [undefined],
    open_topic_name: "none",
    open_topic_index: -1,
    selected: "",
    button_clicked: "",
    editor_toggle: false,
    content: "",
    cell_types: ["Code", "Markdown", "Img", "YouTube"],
    isSiteLoading: true,
    auth_token_notebook: "None",
  };
  componentDidMount() {
    console.log(" NOTEBOOK_INDEX >> Did_Mount");
    Notebook_data(
      this.state.user,
      this.state.open_topic_name,
      this.state.auth_token_notebook
    ).then((data) => {
      this.setState({ open_topic: data });
      // console.log("Notbook_data from mount",data);
    });
    this.setState({ isSiteLoading: false });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log(" NOTEBOOK_INDEX >> Did_Update");
    if (this.state.open_topic_name !== prevState.open_topic_name) {
      this.setState({ isSiteLoading: true });
      Notebook_data(
        this.state.user,
        this.state.open_topic_name,
        this.state.auth_token_notebook
      ).then((data) => {
        this.setState({ open_topic: data });
        this.setState({ isSiteLoading: false });
        console.log(" NOTEBOOK_INDEX >> Did_Update >> inner");
      });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    console.log(" NOTEBOOK_INDEX >> Get_Derived_State_From_Props");
    if (!nextProps.data)
      return console.log("ERR >> data np getDerivedStateFromProps"); // data hasn't been loaded yet so do nothing
    const { data } = nextProps;
    var { open_topic_name, open_topic_index, auth_token_notebook, user } =
      prevState;
    user = data.state.user;
    open_topic_name = data.state.open_topic;
    open_topic_index = data.state.open_topic_index;
    auth_token_notebook = data.state.auth_token;
    console.log(" NOTEBOOK_INDEX >> Get_Derived_State_From_Props >> Auth");
    return { open_topic_name, open_topic_index, auth_token_notebook, user };
  }

  Copy_btn(index) {
    // Copy to Clipbord Button
    var input = document.createElement("input");
    var value = this.state.open_topic.cells[index].source;
    input.setAttribute("value", value);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand("copy");
    document.body.removeChild(input);
    return result;
  }
  editor_toggle = () => {
    this.setState({ editor_toggle: this.state.editor_toggle ? false : true });
    this.setState({ selected: "" });
    // console.log("toggle state changed to ", this.state.editor_toggle);
  };

  editor_on = (index) => {
    // if (this.state.editor_toggle ){
    // };
    this.setState({ selected: index });
    // console.log(this.state.selected, "is selected for editing...");
  };

  def_className = (index, cell_layout) => {
    let selected = this.state.selected === index ? "selected " : "";
    let className = "nb-content cell " + selected + " " + cell_layout;
    return className;
  };

  addCell = (index, cell_type) => {
    // console.log("aDD cell triggered at ",index+1);
    var buton_clic = this.state.button_clicked === "" ? "clicked" : "";
    this.setState({ button_clicked: buton_clic });
    insertCell(
      this.state.open_topic,
      index,
      cell_type,
      this.state.auth_token_notebook
    );
  };
  updateCell_content = (index, value, sub_layout, sub_layout_value, date) => {
    // console.log("updateswll", index, value);
    let topic = this.state.open_topic;
    topic.cells[index].source = value;
    topic.cells[index].cell_layout[sub_layout] = sub_layout_value;
    updateCell(topic, this.state.auth_token_notebook);
  };
  deleteCell = (index) => {
    let topic = this.state.open_topic;
    console.log("updateDelete", topic);
    topic.cells.splice(index, 1);
    updateCell(topic, this.state.auth_token_notebook);
    console.log("updateDelete2", topic);
  };

  render() {
    console.log(" NOTEBOOK_INDEX >> Render");
    var topic = this.state.open_topic;
    // var state = this.state;
    // let Prop = {updatecell: this.updateCell_content};
    // console.log("all state : ",this.state);

    return (
      <div id="notebook">
        <div id="notebook_current">
          <div id="notebook_Row" className="notebook">
            <div id="notebook_title">
              <div className="nb-content title-cell">
                <ToggleMenu />
                <h4 className="topic-title">
                  {topic
                    ? topic.name
                    : console.log("no title found", this.state.topic)}
                </h4>
                <div
                  className="editorToggleBtn"
                  onClick={this.editor_toggle.bind(this)}
                  style={{ float: "right" }}
                >
                  {this.state.editor_toggle ? (
                    <span class="material-icons">edit_off</span>
                  ) : (
                    <span class="material-icons">mode_edit</span>
                  )}
                  {/* {this.state.editor_toggle ? "Editor on" : "Editor off"} */}
                </div>
              </div>
            </div>
            <div className={"nb-content-page"}>
              {this.state.isSiteLoading ? (
                <div>
                  <img alt="loading-img" className="loading-img" src={logo} />
                </div>
              ) : (
                <>
                  {topic.cells ? (
                    topic.cells.map((d, i) => (
                      <div key={d + " Cells " + i} className={"cell-wrapper"}>
                        <div
                          className={this.def_className(
                            i,
                            d.cell_layout.cell_type
                          )}
                        >
                          <div
                            className="editor-trigger"
                            onClick={this.editor_on.bind(this, i)}
                          >
                            <div className="cell-content">
                              {
                                // d.cell_layout.cell_type==="Code" ?
                                this.state.cell_types.includes(
                                  d.cell_layout.cell_type
                                ) ? (
                                  this.state.selected === i &&
                                  this.state.editor_toggle ? (
                                    <>
                                      <div className="cell-content-top">
                                        <span className="cell-del-button"
                                          onClick={this.deleteCell.bind(
                                            this,
                                            i
                                          )}
                                        >
                                          <i className="material-icons">
                                            delete
                                          </i>
                                        </span>
                                      </div>
                                      <Editor
                                        data={{
                                          d: d,
                                          updatecell: this.updateCell_content,
                                          index: i,
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <Display
                                        data={{
                                          d: d,
                                          updatecell: this.updateCell_content,
                                          index: i,
                                        }}
                                      />
                                    </>
                                  )
                                ) : (
                                  <></>
                                )
                              }
                            </div>
                            {/* <i className = "material-icons">delete</i> */}
                          </div>
                        </div>
                        <div className="nb-content add-cell">
                          <div className="nb-content add-cell-buttons">
                            {this.state.cell_types.map((cell_type) => (
                              <colab-toolbar-button
                                key={cell_type + " key for cell " + i}
                                className={
                                  " nb-content add-" + { cell_type } + "     "
                                }
                                onClick={this.addCell.bind(this, i, cell_type)}
                                icon="icons:add"
                                title={"Add " + cell_type + " Here"}
                              >
                                {cell_type}
                                {/* <span className="material-icons-two-tone">code</span> */}
                                {/* <i className = "material-icons">code</i> */}
                              </colab-toolbar-button>
                            ))}
                          </div>
                          <hr />
                        </div>
                      </div>
                    ))
                  ) : (
                    <>
                      <div>No NoteBook Data Found</div>
                    </>
                  )}
                </>
              )}
              <div id="notebook_footer"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default notebook;
